import { create } from 'zustand';

interface HandleSecurityRefreshState {
    refreshSecurity: boolean;
    setRefreshSecurity: (open: boolean) => void;
}

// Create the Zustand store with types
const HandleSecurityRefreshStore = create<HandleSecurityRefreshState>((set) => ({
    refreshSecurity: false,
    setRefreshSecurity: (open: boolean) => set({ refreshSecurity: open }),
}));

export default HandleSecurityRefreshStore;
